import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Badge, Button, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { Applications, Groups, User } from '../../clients/aasServerClient.generated';
import { getApplicationName } from '../../stores/applications/selectors';
import { adEnabled, hasPrivilege, hideGroups } from '../../stores/auth/selectors';
import { getGroupName } from '../../stores/groups/selectors';
import { RootState } from '../../stores/store';
import { select, unselect } from '../../stores/tables/actionCreators';
import { isSelected } from '../../stores/tables/selectors';
import { deleteUsers } from '../../stores/users/actionCreators';
import { isOldUser, isSuperAdmin, isUserAdmin, isWorkspaceAdmin } from '../../stores/users/selectors';
import { getWorkspaceName } from '../../stores/workspaces/selectors';
import ConfirmModal from '../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps, RouteComponentProps {
    user: User;
    selected: boolean;
    adEnabled?: boolean;
    getApplicationName: (id: string) => string;
    getGroupName: (id: string) => string;
    getWorkspaceName: (id: string) => string;
    hideGroups?: boolean;

    isUserAdmin: (id: string) => boolean;
    isSuperAdmin: (id: string) => boolean;
    isWorkspaceAdmin: (id: string) => boolean;
    isOldUser: (id: string) => boolean;

    hasPrivilege: (name: string[]) => boolean;

    select: (id: string) => void;
    unselect: (id: string) => void;
    delete: (id: string) => void;
}

interface State {
    showDelete: boolean;
}

class UsersTableRow extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            showDelete: false,
        };
    }

    public render() {
        const t = this.props.translate;
        const user = this.props.user;
        return (
            <tr
                className={classnames(
                    'table-row',
                    this.props.selected ? 'selected' : '',
                    this.props.user.active ? '' : 'inactive')}
                onClick={(e) => {
                    this.props.selected ?
                        this.props.unselect(user.id) : this.props.select(user.id);
                }}
            >
                <td ><Input type="checkbox" checked={this.props.selected} onChange={() => null} /></td>
                {this.props.hasPrivilege(['SUPER_ADMIN']) ? (
                    <td>
                        {this.props.isOldUser(user.id) ? (
                            <Badge color="light" className="mr-1">
                                <FontAwesomeIcon icon={['fas', 'history']} />
                            </Badge>
                        ) : null}
                        {/* {this.props.isSuperAdmin(user.id) ? (
                        <Badge color="danger" className="mr-1">
                            <FontAwesomeIcon icon={['fas', 'user-crown']} />
                        </Badge>
                    ) : null}
                    {this.props.isWorkspaceAdmin(user.id) ? (
                        <Badge color="info" className="mr-1">
                            <FontAwesomeIcon icon={['fas', 'user-crown']} />
                        </Badge>
                    ) : null}
                    {this.props.isUserAdmin(user.id) ? (
                        <Badge color="primary" className="mr-1">
                            <FontAwesomeIcon icon={['fas', 'user-crown']} />
                        </Badge>
                    ) : null} */}
                    </td>
                ) : null}
                {this.props.adEnabled ? <td>{user.ad_identifier}</td> : null}
                <td>
                    {user.email || user.username}
                </td>
                <td>{user.first_name}</td>
                <td>{user.last_name}</td>
                <td>{this.getAppCell(user.applications)}</td>
                {this.props.hideGroups === false ? (
                    <td>{this.getGroupCell(user.groups)}</td>
                ) : null}
                <td>{this.getWorkspaceCell(user.workspace?.id)}</td>
                <td>{this.getCreatetime(user.createdAt)}</td>
                <td className="icon-btn-td">
                    <Button
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.history.push('/users/edit/' + this.props.user.id);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'pencil']} className="noMarginRight" />
                    </Button>
                </td>
                <td className="icon-btn-td">
                    <Button
                        color="danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showDelete: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} className="noMarginRight" />
                    </Button>
                    <ConfirmModal
                        header={t('users.modal.delete.header') as string}
                        confirmText={t('users.modal.delete.delete') as string}
                        isOpen={this.state.showDelete}
                        buttonColor="danger"
                        cancel={() => this.setState({ showDelete: false })}
                        confirm={() => this.props.delete(this.props.user.id)}
                    >
                        {`${t('users.modal.delete.text')} ${this.props.user.email ||
                            this.props.user.username || this.props.user.id}`}
                    </ConfirmModal>
                </td>
            </tr>
        );
    }

    private getAppCell = (apps?: Applications[]) => {
        if (apps === undefined || apps.length === 0) {
            return '';
        } else if (apps.length > 1) {
            return this.props.translate('users.table.cells.assigned', { number: apps.length });
        } else {
            return this.props.getApplicationName(apps[0].id);
        }
    }
    private getCreatetime = (ctime?: Date ) =>
    {
        if (ctime === undefined)
        {
            return '';
        }
        else
        {
            return this.formattedDate(ctime);
        }
    }
    private formattedDate(d: Date) 
    {
        let month = String(d.getMonth() + 1);
        let day = String(d.getDate());
        const year = String(d.getFullYear());      
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;      
        return `${day}/${month}/${year}`;
      }

    private getGroupCell = (groups?: Groups[]) => {
        if (groups === undefined || groups.length === 0) {
            return '';
        } else if (groups.length > 1) {
            return this.props.translate('users.table.cells.assigned', { number: groups.length });
        } else {
            return this.props.getGroupName(groups[0].id);
        }
    }

    private getWorkspaceCell = (workspaceId?: string) => {
        if (workspaceId === undefined) {
            return '';
        } else {
            return this.props.getWorkspaceName(workspaceId);
        }

    }
}

const mapStateToProps = (state: RootState, props: { user: User }) => ({
    getApplicationName: getApplicationName(state),
    getGroupName: getGroupName(state),
    getWorkspaceName: getWorkspaceName(state),
    hasPrivilege: hasPrivilege(state),
    hideGroups: hideGroups(state),
    selected: isSelected(state, 'users', props.user.id),

    isOldUser: isOldUser(state),
    isSuperAdmin: isSuperAdmin(state),
    isUserAdmin: isUserAdmin(state),
    isWorkspaceAdmin: isWorkspaceAdmin(state),

    adEnabled: adEnabled(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    delete: (id: string) => dispatch(deleteUsers([id])),
    select: (id: string) => dispatch(select('users', id)),
    unselect: (id: string) => dispatch(unselect('users', id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(UsersTableRow)));